<template>
    <div class="app-callback">
       <div >
    <div class="container">
     
    

      <div >
        <div class="col-md-12 col-sm-12 d-flex justify-content-center align-items-center text-center" id="test-text">
          <div class="partners-container owl-carousel  hero-slider">
            <div class="partner-item" v-for="(partner, i) in partners" :key="i">
              <p>{{partner.message}}</p>
              <!-- <img :src="partner.image" :alt="partner.name"> -->
              <div class="col-md-12 d-flex justify-content-center align-items-center text-center" >
          <span class="test-name" style="color:#CDA96F">{{partner.name}}  <small style="color:#666666"> - {{partner.location}}</small></span>
                      
                     
          </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
       
    </div>
</template>

<script>
import axios from "axios";
import { TestArray } from "../config";

export default {
  name: "Callback",
  data() {
    return {
      partners: TestArray
    };
  }, 
   created() {
    this.$nextTick(() => {
      var owl = $(".partners-container");
      owl.owlCarousel({
        loop: true,
        margin: 10,
        autoplay: true,
        autoplayHoverPause: true,
        responsiveClass: true,
        responsive: {
          0: {
            items: 1,
            nav: false
          },
          600: {
            items: 1,
            nav: false
          },
          1000: {
            items: 1,
            loop: true
          },
          1120: {
                  items: 1,
                  dots: false,
                  nav: true
                }
        }
      });
    });
  }
  
};
</script>

<style scoped>
</style>
